import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import styles from '../styles/components/sidePanelCard.module.scss';

const SidePanelCard = ({
  titleId, textId, image, altTextId, externalLink, intl,
}) => {
  const altText = intl.formatMessage({ id: altTextId });
  return (
    <a href={externalLink} target="_blank" rel="noopener noreferrer" className={styles.container}>
      <h2>
        <FormattedMessage id={titleId} />
      </h2>
      <div className={styles.contentWrapper}>
        <div className={styles.cardContent}>
          <div className={styles.imageWrapper}><img src={image} alt={altText} /></div>
          <FormattedMessage id={textId} />
        </div>
      </div>
    </a>
  );
};

SidePanelCard.propTypes = {
  titleId: PropTypes.string.isRequired,
  textId: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  altTextId: PropTypes.string.isRequired,
  externalLink: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(SidePanelCard);
